import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const FETCH_TASK_SUBMISSIONS_REQUEST = "FETCH_TASK_SUBMISSIONS_REQUEST";
export const FETCH_TASK_SUBMISSIONS_SUCCESS = "FETCH_TASK_SUBMISSIONS_SUCCESS";
export const FETCH_TASK_SUBMISSIONS_FAILURE = "FETCH_TASK_SUBMISSIONS_FAILURE";

export const UPDATE_TASK_STATUS_REQUEST = "UPDATE_TASK_STATUS_REQUEST";
export const UPDATE_TASK_STATUS_SUCCESS = "UPDATE_TASK_STATUS_SUCCESS";
export const UPDATE_TASK_STATUS_FAILURE = "UPDATE_TASK_STATUS_FAILURE";

export const BULK_UPDATE_TASK_STATUS_REQUEST = "BULK_UPDATE_TASK_STATUS_REQUEST";
export const BULK_UPDATE_TASK_STATUS_SUCCESS = "BULK_UPDATE_TASK_STATUS_SUCCESS";
export const BULK_UPDATE_TASK_STATUS_FAILURE = "BULK_UPDATE_TASK_STATUS_FAILURE";


// export const fetchAllTaskSubmissions = () => {
//   return async (dispatch) => {
//     dispatch({ type: FETCH_TASK_SUBMISSIONS_REQUEST });

//     const token = localStorage.getItem("token");

//     try {
//       const response = await axios.get(
//         `${BASE_URL}/v1/api/admin/getAllTaskSubmitByAdmin`,
//         {
//           headers: { Authorization: token },
//         }
//       );

//       if (response?.data?.meta?.status) {
//         dispatch({
//           type: FETCH_TASK_SUBMISSIONS_SUCCESS,
//           payload: response.data.data,
//         });
//       } else {
//         dispatch({
//           type: FETCH_TASK_SUBMISSIONS_FAILURE,
//           payload: response.data?.meta?.message || "Failed to fetch task submissions.",
//         });
//       }
//     } catch (error) {
//       const message = error.response?.data?.meta?.message || error.message;
//       dispatch({
//         type: FETCH_TASK_SUBMISSIONS_FAILURE,
//         payload: message,
//       });
//     }
//   };
// };

export const fetchAllTaskSubmissions = (params = {}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_TASK_SUBMISSIONS_REQUEST });

    const token = localStorage.getItem("token");

    const {
      page = 1,
      limit = 10,
      // district = "",
      // municipality = "",
      fromDate = "",
      toDate = "",
      search = "",
      status = ""
    } = params;

    try {
      const response = await axios.get(
        `${BASE_URL}/v1/api/admin/getAllTaskSubmitByAdmin`,
        {
          headers: { Authorization: token },
          params: {
            page,
            limit,
            // district,
            // municipality,
            fromDate: fromDate || null,
            toDate: toDate || null,
            search,
            status
          },
        }
      );

      if (response?.data?.meta?.status) {
        dispatch({
          type: FETCH_TASK_SUBMISSIONS_SUCCESS,
          payload: {
            data: response.data.data || [],
            meta: response.data.meta || {},
          },
        });
      } else {
        dispatch({
          type: FETCH_TASK_SUBMISSIONS_FAILURE,
          payload:
            response.data?.meta?.message ||
            "Failed to fetch task submissions.",
        });
      }
    } catch (error) {
      const message =
        error.response?.data?.meta?.message || error.message;
      dispatch({
        type: FETCH_TASK_SUBMISSIONS_FAILURE,
        payload: message,
      });
    }
  };
};


export const updateTaskStatus = (id, status) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_TASK_STATUS_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        `${BASE_URL}/v1/api/update-task-status`,
        { id, status },
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.meta?.status) {
        dispatch({ type: UPDATE_TASK_STATUS_SUCCESS, payload: response.data });

        // ✅ Refresh the task list after update
        dispatch(fetchAllTaskSubmissions());

        toast.success("Task status updated successfully.");
      } else {
        dispatch({
          type: UPDATE_TASK_STATUS_FAILURE,
          payload: response.data?.meta?.message || "Failed to update status",
        });
        toast.error(response.data?.meta?.message || "Failed to update status");
      }
    } catch (err) {
      const message = err?.response?.data?.meta?.message || err.message;
      dispatch({ type: UPDATE_TASK_STATUS_FAILURE, payload: message });
      toast.error(message);
    }
  };
};


export const bulkUpdateTaskStatus = (ids, status) => {
  return async (dispatch) => {
    dispatch({ type: BULK_UPDATE_TASK_STATUS_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        `${BASE_URL}/v1/api/bulk-update-task-status`,
        { ids, status },
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.meta?.status) {
        dispatch({ type: BULK_UPDATE_TASK_STATUS_SUCCESS });

        dispatch(fetchAllTaskSubmissions());
        toast.success("Bulk status updated successfully.");
      } else {
        dispatch({
          type: BULK_UPDATE_TASK_STATUS_FAILURE,
          payload: response.data?.meta?.message || "Bulk update failed",
        });
        toast.error(response.data?.meta?.message || "Bulk update failed");
      }
    } catch (err) {
      const message = err?.response?.data?.meta?.message || err.message;
      dispatch({ type: BULK_UPDATE_TASK_STATUS_FAILURE, payload: message });
      toast.error(message);
    }
  };
};